module.exports = __webpack_public_path__ + "img/z1.feb2624d.png";